import { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { updatePriceGroupField } from "redux/slices/PriceGroups";
import { calculateMarkup } from "helpers/data/dataHandling";
import { modifyPriceGroupsPrice, getPriceGroupsPrice } from "redux/slices/PriceGroups";
import { Spinner, FormInput } from "components";

type stockProps = {
    show: boolean;
    handleClose: () => void;
    selectedStock: number;
};

export function Stock(props: stockProps) {
    const dispatch = useAppDispatch();
    const selectedStock = props["selectedStock"] || 0;
    const priceGroup = useAppSelector((state: RootState) => state.priceGroups);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [cost, setCost] = useState(0);
    const [newGp, setNewGp] = useState<any>("");
    const [newSellPrice, setNewSellPrice] = useState<any>("");

    useEffect(() => {
        setNewGp(parseFloat(calculateMarkup(cost, newSellPrice)));
    }, [newSellPrice]);

    useEffect(() => {
        if (props.show) {
            priceGroup.stock.forEach((item: any) => {
                if (item.managedStockId === selectedStock) {
                    setCost(item.managedStockCost);
                    setName(item.managedStockName);
                    setNewSellPrice(item.newPrice);
                }
            });
        } else {
            setName("");
            setCost(0);
            setNewGp("");
            setNewSellPrice("");
        }
    }, [props.show, selectedStock]);

    async function saveSelectedStock() {
        setLoading(true);
        const cunrrentStock: any = priceGroup.stock.filter((item: any) => item.managedStockId === selectedStock);
        await dispatch(modifyPriceGroupsPrice([{
            ...cunrrentStock[0],
            newPrice: newSellPrice.toFixed(2),
        }])).then(async () => {
            await dispatch(getPriceGroupsPrice({ 
                priceGroupIds: [priceGroup.id],
            }))
        });
        setLoading(false);
        props.handleClose();
    }

    function handleUpdate(key: string, value: any) {
        dispatch(updatePriceGroupField({ key: key, value: value }));
    }

    return (
        <Modal size="sm" centered show={props.show} onHide={props.handleClose} className="modal-md">
            <Modal.Header closeButton>
                <Modal.Title>{name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mt-3 mb-3 pe-0">
                    <Row className="ms-0">
                        <Col xs={5}>
                            <p className="popup-form-text-field">Cost</p>
                        </Col>
                        <Col xs={7}>
                            <FormInput
                                min={1}
                                disabled
                                type="number"
                                prepend="$"
                                name="price-level-cost"
                                containerClass={"mb-2"}
                                value={cost}
                            />
                        </Col>
                    </Row>
                    <Row className="ms-0">
                        <Col xs={5}>
                            <p className="popup-form-text-field">New GP%</p>
                        </Col>
                        <Col xs={7}>
                            <FormInput
                                min={0}
                                disabled
                                append="%"
                                type="number"
                                name="price-level-new-gp"
                                containerClass={"mb-2"}
                                value={newGp}
                            />
                        </Col>
                    </Row>
                    <Row className="ms-0">
                        <Col xs={5}>
                            <p className="popup-form-text-field">New Sell Price</p>
                        </Col>
                        <Col xs={7}>
                            <FormInput
                                min={0}
                                required
                                type="number"
                                prepend="$"
                                name="price-level-new-sell-price"
                                containerClass={"mb-2"}
                                value={newSellPrice}
                                onChange={(e) => setNewSellPrice(parseFloat(e.target.value))}
                                onBlur={(e) => {
                                    let parsedValue = parseFloat(e.target.value);
                                    if (Number.isNaN(parsedValue) || parsedValue < 0) {
                                        setNewSellPrice(1);
                                    } else {
                                        setNewSellPrice(parsedValue);
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                </Row>
                <Modal.Footer>
                    <Button variant="secondary" className="cta-button" onClick={props.handleClose}>Cancel</Button>
                    <Button variant="primary" className="me-0 cta-button" onClick={saveSelectedStock}>
                        {loading ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
                        {loading ? <>Saving...</> : <>Save</>}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
}